import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkMaintenanceMode = useCallback(async () => {
    try {
      // Primary: Check via edge function for server-side enforcement
      const { data, error } = await supabase.functions.invoke('check-maintenance');
      
      if (!error && data) {
        setIsMaintenanceMode(data.maintenance || false);
        return data.maintenance || false;
      }
      
      // Fallback: Direct database check if edge function fails
      const { data: dbData, error: dbError } = await supabase
        .from('site_information')
        .select('maintenance_mode')
        .single();

      if (dbError) {
        console.error('Error checking maintenance mode:', dbError);
        setIsMaintenanceMode(false);
        return false;
      }
      
      setIsMaintenanceMode(dbData?.maintenance_mode || false);
      return dbData?.maintenance_mode || false;
    } catch (error) {
      console.error('Error checking maintenance mode:', error);
      setIsMaintenanceMode(false);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkMaintenanceMode();
    // Removed: refetch on every navigation - causes duplicate API calls
    // Maintenance mode changes are rare, checked once on app load
  }, [checkMaintenanceMode]);

  return { isMaintenanceMode, loading, refetch: checkMaintenanceMode };
};
